@for (headerRow of headerRows; track headerRow; let level = $index) {
  @for (head of headerRow; track trackByHeadNode($index, head)) {
    <span
      class="mat-header-cell tree-table-header"
      role="columnheader"
      [ngClass]="[
        head.shade === true ? 'shade' : '',
        'rowspan-' + head.rowspan,
        'colspan-' + head.colspan,
        'level-' + level,
        head.rightmostCellInHeader === true ? 'rightmost' : '',
        head.leftmostCellInHeader === true ? 'leftmost' : '',
        head.firstColumnInHeader === true ? 'firstColumn' : '',
        head.leftmostOfSecondColumn === true ? 'leftmostOfSecondColumn' : '',
      ]"
    >
      @if (isRawString(head.widget)) {
        {{ head.widget }}
      } @else {
        @if (isExpression(head.widget)) {
          {{ head.widget | parse: context | async }}
        } @else {
          <ng-container
            [dynamicWidget]="head.widget"
            [context]="context"
          ></ng-container>
        }
      }
    </span>
  }
}
@for (node of nodes$ | async; track node) {
  <div role="row">
    @for (dataColumn of activeColumn; track dataColumn; let first = $first) {
      @if (first) {
        @if (node.expandable) {
          <span
            class="tb-tree-cell mat-cell expandable"
            role="gridcell"
            [style.paddingLeft.px]="node.level * 8"
            [style.minWidth]="
              dataColumn.width > 0 ? dataColumn.width + 'px' : 'max-content'
            "
            [ngClass]="dataColumn.shade === true ? 'shade' : ''"
            (dblclick)="treeControl.toggle(node)"
          >
            <button mat-icon-button (click)="treeControl.toggle(node)">
              <mat-icon class="mat-icon-rtl-mirror">
                {{
                  treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                }}
              </mat-icon>
            </button>
            @if (
              mergeContexts(
                context,
                wrapContext(node, input?.rowDataAlias || 'node')
              );
              as mergedContext
            ) {
              @if (!isExpression(dataColumn.widget)) {
                <ng-container
                  [dynamicWidget]="
                    dataColumn.widget
                      | parse
                        : mergedContext
                        : { maxParseDepth: 1, keyWhitelist: ['id'] }
                      | async
                  "
                  [context]="mergedContext"
                ></ng-container>
              } @else {
                {{ dataColumn.widget | parse: mergedContext | async }}
              }
            }
          </span>
        } @else {
          <span
            class="tb-tree-cell mat-cell"
            role="gridcell"
            [style.paddingLeft.px]="node.level * 8"
            [style.minWidth]="
              dataColumn.width > 0 ? dataColumn.width + 'px' : 'max-content'
            "
            [ngClass]="[
              dataColumn.shade === true ? 'shade' : '',
              input.firstColumnSticky === true ? 'sticky' : '',
            ]"
          >
            @if (
              mergeContexts(
                context,
                wrapContext(node, input?.rowDataAlias || 'node')
              );
              as mergedContext
            ) {
              @if (!isExpression(dataColumn.widget)) {
                <ng-container
                  [dynamicWidget]="
                    dataColumn.widget
                      | parse
                        : mergedContext
                        : { maxParseDepth: 1, keyWhitelist: ['id'] }
                      | async
                  "
                  [context]="mergedContext"
                ></ng-container>
              } @else {
                {{ dataColumn.widget | parse: mergedContext | async }}
              }
            }
          </span>
        }
      } @else {
        <span
          class="tb-tree-cell mat-cell"
          role="gridcell"
          [ngClass]="dataColumn.shade === true ? 'shade' : ''"
          [style.minWidth]="
            dataColumn.width > 0 ? dataColumn.width + 'px' : 'initial'
          "
        >
          @if (
            mergeContexts(
              context,
              wrapContext(node, input?.rowDataAlias || 'node')
            );
            as mergedContext
          ) {
            @if (!isExpression(dataColumn.widget)) {
              <ng-container
                [dynamicWidget]="
                  dataColumn.widget
                    | parse
                      : mergedContext
                      : { maxParseDepth: 1, keyWhitelist: ['id'] }
                    | async
                "
                [context]="mergedContext"
              ></ng-container>
            } @else {
              {{ dataColumn.widget | parse: mergedContext | async }}
            }
          }
        </span>
      }
    }
  </div>
}
